// Settings page configuration - extracted from SettingsPageWrapper for file size optimization
// Migrated to Paraglide JS - using native Paraglide functions
import {
  settings_sections_account,
  settings_sections_billing,
  settings_language_title,
  settings_language_description,
  settings_password_title,
  settings_password_description,
  settings_subscription_title,
  settings_subscription_description,
  settings_payment_dashboard_title,
  settings_payment_dashboard_description,
  settings_subscription_management_title,
  settings_subscription_management_description,
  settings_payment_methods_title,
  settings_payment_methods_description,
  settings_orders_title,
  settings_orders_description
} from '@paraglide/messages';
import CreditCardIcon from 'lucide-react/dist/esm/icons/credit-card';
import GlobeIcon from 'lucide-react/dist/esm/icons/globe';
import KeyIcon from 'lucide-react/dist/esm/icons/key';
import { SettingsSection } from '@edusense/features-settings';
import LanguageSelector from '../../../../src/components/LanguageSelector';

export const createSettingsSections = (navigate: (path: string) => void): SettingsSection[] => [
  {
    id: 'account',
    title: settings_sections_account(),
    items: [
      {
        id: 'language',
        title: settings_language_title(),
        icon: GlobeIcon,
        description: settings_language_description(),
        customComponent: <LanguageSelector />,
      },
      {
        id: 'password',
        title: settings_password_title(),
        icon: KeyIcon,
        description: settings_password_description(),
        path: '/settings/password',
      },
    ]
  },
  {
    id: 'billing',
    title: settings_sections_billing(),
    items: [
      {
        id: 'subscription',
        title: settings_subscription_title(),
        icon: CreditCardIcon,
        description: settings_subscription_description(),
        path: '/pricing',
      },
      {
        id: 'payment-dashboard',
        title: settings_payment_dashboard_title(),
        icon: CreditCardIcon,
        description: settings_payment_dashboard_description(),
        path: '/payment/dashboard',
      },
      {
        id: 'subscription-management',
        title: settings_subscription_management_title(),
        icon: CreditCardIcon,
        description: settings_subscription_management_description(),
        path: '/subscription/management',
      },
      {
        id: 'payment-methods',
        title: settings_payment_methods_title(),
        icon: CreditCardIcon,
        description: settings_payment_methods_description(),
        path: '/payment/methods',
      },
      {
        id: 'orders',
        title: settings_orders_title(),
        icon: CreditCardIcon,
        description: settings_orders_description(),
        path: '/payment/orders',
      },
    ]
  }
];